import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
//import { EUserType } from 'src/app/domain/enum/user-type';
import { User } from 'src/app/domain/user';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

    constructor(
        private snackBar: MatSnackBar,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private coreData: CoreData) { }

    ngOnInit(): void {

        // Already authenticated in another app
        this.route.queryParams.subscribe(async params => {

            this.coreData.WithOauth2 = true;
            if (!params.token) {
                NotificationManager.handleWarning('', this.snackBar);
                return;
            }
            
            this.coreData.Token = params.token;
            this.coreData.SelectedScopeCode = decodeURIComponent(params.selectedScope);
    
            // await new Promise((resolve, reject) => {
            //     this.userService.getUserType().subscribe((type: EUserType) => {
            //         this.coreData.UserType = type;
            //         resolve(true);
            //     });
            // });
            //   this.coreData.SelectedScopeCode = decodeURIComponent(params.selectedScope);

            // Get User Scope list
            // await new Promise((resolve, reject) => {
            //     this.userService.getScopeList().subscribe(x => {
            //         if (x) {
            //             this.coreData.ScopeList = x;
            //             this.coreData.SelectedScopeCode = x[0].Code;
            //         }
            //         resolve(true);
            //     });
            // });

            // redirect to your default page.
            this.router.navigate([ENavigationRoute.Config]);
        });
    }
}
